import CONFIG from '../environmentConfig/index'

export const getImage = (image)=>{
    return `${CONFIG.S3_BASE_URL}/images/${image}`
}